export const ElevationDownIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.557812 1.44254L9.49141 10.3753H2.875C2.70924 10.3753 2.55027 10.4412 2.43306 10.5584C2.31585 10.6756 2.25 10.8346 2.25 11.0003C2.25 11.1661 2.31585 11.3251 2.43306 11.4423C2.55027 11.5595 2.70924 11.6253 2.875 11.6253H11C11.1658 11.6253 11.3247 11.5595 11.4419 11.4423C11.5592 11.3251 11.625 11.1661 11.625 11.0003V2.87535C11.625 2.70959 11.5592 2.55062 11.4419 2.43341C11.3247 2.3162 11.1658 2.25035 11 2.25035C10.8342 2.25035 10.6753 2.3162 10.5581 2.43341C10.4408 2.55062 10.375 2.70959 10.375 2.87535V9.49175L1.44219 0.55816C1.38412 0.500091 1.31518 0.454028 1.23931 0.422602C1.16344 0.391175 1.08212 0.375 1 0.375C0.917878 0.375 0.83656 0.391175 0.76069 0.422602C0.684819 0.454028 0.615881 0.500091 0.557812 0.55816C0.499743 0.616229 0.453681 0.685167 0.422255 0.761037C0.390828 0.836908 0.374652 0.918226 0.374652 1.00035C0.374652 1.08247 0.390828 1.16379 0.422255 1.23966C0.453681 1.31553 0.499743 1.38447 0.557812 1.44254Z"
        fill="#D9D9D9"
      />
    </svg>
  )
}
